import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import Logo from '../images/logo.png'
import DashboardIcon from '../images/dashboard.svg'
import OrdersIcon from '../images/orders.svg'
import SalesRepIcon from '../images/sales-rep.svg'
import SettingsIcon from '../images/settings.svg'
import TeaIcon from '../images/tea.svg'
import FarmIcon from '../images/farm.svg'
import WarehouseIcon from '../images/warehouse.svg'
import UpIcon from '../images/up.svg'
import { useDispatch, useSelector } from 'react-redux'
import { logout, updateUserRole } from '../redux/slice/authSlice'
import { BiCart, BiLeaf, BiLogOut, BiSolidDashboard } from 'react-icons/bi'
import { PiCirclesFour, PiFactory, PiFarm, PiTruckTrailer, PiUsers, PiUsersFour, PiWarehouse } from 'react-icons/pi'
import { LuSettings2 } from 'react-icons/lu'
import { TbUsers } from 'react-icons/tb'
import { BsBoxes, BsBuilding, BsTruck } from 'react-icons/bs'
import { FaBoxesStacked, FaClipboardList, FaWarehouse } from 'react-icons/fa6'
import { FiLogOut } from 'react-icons/fi'
import { MdUpdate, MdViewList, MdWaterDrop } from 'react-icons/md'
import { CiViewList } from 'react-icons/ci'
import { HiOutlineClipboardList } from 'react-icons/hi'
import { authAxios } from '../helpers/axios'
import { ErrorToast } from '../helpers/toasters'
import { IoWaterOutline } from 'react-icons/io5'


const SidebarMenuSubItem = React.memo(({active,setActive,data,collapsed})=>
{
    return  <div className={`menu-sub-item relative my-3 mb-2 ${collapsed ? 'pl-2' : 'pl-4'}`}>
        <NavLink to={data.url} className={({ isActive, isPending }) =>
    isActive ? " inline-block menu-sub-active group active" : "inline-block"
  }>
            <div className={`w-auto mx-auto flex rounded-md items-center group-[.menu-sub-active]:bg-[#313B53] transition-all duration-[300ms] ${collapsed ? 'ml-4 px-4' : 'ml-10 px-4'}`}>
            <div className='py-3'>
            </div>
            <div className={`${!collapsed ? '' :'ml-0'}`}>
                <p className={`text-[13px] whitespace-nowrap font-normal transition-all duration-[300ms] text-[#151515] group-[.active]:text-white ${!collapsed ? 'w-auto opacity-100' :'w-0 overflow-hidden opacity-0'}`}>{data.label}</p>
            </div>
        </div>
        </NavLink>
        </div>
})

const SidebarMenuItem = React.memo(({active,setActive,data,collapsed,Icon})=>
{
    return  <div className={`menu-item transition-all relative  ${active === data.id && data.childrens && data.childrens.length >0 ? 'menu-item-active border-b-stone-700 border-b-[0]' : ''}`} onClick={()=>setActive(data.id)}>
        <NavLink to={data.url} className={({ isActive, isPending }) =>
        {
            if(isActive) setActive(data.id);
            return isActive ? " block group my-2 parent-active opacity-100 bg-[#e6f3f1] rounded-md shadow-none border border-gray-100" : " filter grayscale block border border-transparent my-2"
        }
}>
            <div className={`w-full flex px-4 items-center `}>
                <div className='w-full flex items-center'>
                    <div className='py-2'>
                        {data.id === 1 ? <PiCirclesFour color={active === 1 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 2 ? <HiOutlineClipboardList color={active === 2 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 3 ? <BiCart color={active === 3 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 4 ? <PiFactory color={active === 4 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 5 ? <BsBuilding color={active === 5 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 6 ? <PiTruckTrailer color={active === 6 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 7 ? <BsBoxes color={active === 7 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 12 ? <BiLeaf color={active === 7 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 13 ? <IoWaterOutline color={active === 7 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 14 ? <MdUpdate color={active === 7 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 11 ? <LuSettings2 color={active === 7 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 10 ? <PiFarm color={active === 7 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 8 ? <PiUsersFour color={active === 8 ? '#225442' : '#000'} fontSize={20}/> : null}
                        {data.id === 9 ? <PiWarehouse color={active === 9 ? '#225442' : '#000'} fontSize={20}/> : null}
                    </div>
                    {!collapsed ? <div className='ml-4'>
                        <p className={`text-[13px] tracking-[-.1px] font-medium  ${active === data.id ? 'text-[#225442]' : 'text-[#151515]'}`}>{data.label}</p>
                    </div> : null}
                </div>
                {!collapsed && data.childrens && data.childrens.length > 0 ? <div className=''>
                    <img src={UpIcon} className={`w-3 h-3 ${active !== data.id ? 'origin-center rotate-180' : ''}`}/>
                </div> : null}
        </div>
        </NavLink>
        {
            data.childrens && data.childrens.length > 0 ? <div className={`overflow-hidden transition-all ${active !== data.id ? 'h-0 ' : 'h-full py-4'}`}>
            {
                data.childrens.map((item,index)=>
                {
                    return <SidebarMenuSubItem data={item} key={index} active={active} collapsed={collapsed}/>
                })
            }
        </div> : null
        }
        </div>
})

const Sidebar = () => {

    const [activeMenu,setActiveMenu] = useState(1)
    const [collapsed,setCollapsed] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const authInfo = useSelector(state=>state.auth)

    const {pathname} = useLocation();

    async function precheckUser(){
        try {
            let userInfo = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/user/precheck`)
            dispatch(updateUserRole({role:userInfo.data.role}))
        } catch (error) {
            ErrorToast('Error getting User Info')
        }
    }

    useEffect(()=>{
        if(!authInfo.isLoggedIn || !authInfo.token) {
            navigate('/login')
        }
    },[authInfo.isLoggedIn, authInfo.token])

    useEffect(() => {
        if (!authInfo.role) return;

        const allowedRoutes = {
            production: ['/manufacturing', '/shipping', '/','/product-stocks','/blended-tea','/stocks','/common-bom','/raw-tea'],
            sales: ['/','/sales','/buyers'],
            purchase: ['/purchase', '/','/stocks','/common-bom','/purchase-stocks','/suppliers'],
            tea: ['/','/sales','/raw-tea', '/blended-tea','/warehouse','/gardens','/buyers','/settings','/updates','/users']
        };

        if (authInfo.role === 'admin') return;

        const currentAllowedRoutes = allowedRoutes[authInfo.role] || [];
        
        const isAllowed = currentAllowedRoutes.some(route => 
            pathname === route || pathname.startsWith(`${route}/`)
        );

        if (!isAllowed) {
            navigate(currentAllowedRoutes[0]);
        }
    }, [pathname, authInfo.role]);

    const onLogout = useCallback(()=>{
        dispatch(logout())
    }, [dispatch])

    const roleBasedMenuItems = {
        sales:[
            {
                id: 1,
                label: 'Dashboard',
                icon: DashboardIcon,
                childrens: null,
                url: '/'
            },
            {
                id: 2,
                label: 'Sales',
                icon: OrdersIcon,
                childrens: null,
                url: '/sales'
            },
            {
                id: 5,
                label: 'Buyers',
                icon: SettingsIcon,
                url: "/buyers",
            },
        ],
        tea:[
            {
                id: 1,
                label: 'Dashboard',
                icon: DashboardIcon,
                childrens: null,
                url: '/'
            },
            {
                id: 2,
                label: 'Sales',
                icon: OrdersIcon,
                childrens: null,
                url: '/sales'
            },
            {
                id: 12,
                label: 'Raw Tea',
                icon: TeaIcon,
                url: '/raw-tea',
            },
            {
                id: 13,
                label: 'Blended Tea',
                icon: TeaIcon,
                url: '/blended-tea',
            },
            {
                id: 9,
                label: 'Warehouse',
                icon: WarehouseIcon,
                url: '/warehouse',
            },
            {
                id: 10,
                label: 'Gardens',
                icon: FarmIcon,
                url: "/gardens",
            },
            {
                id: 11,
                label: 'Settings',
                icon: SettingsIcon,
                url: '/settings',
            },
        ],
        production: [
            {
                id: 1,
                label: 'Dashboard',
                icon: DashboardIcon,
                childrens: null,
                url: '/'
            },
            {
                id: 4,
                label: 'Manufacturing',
                icon: SalesRepIcon,
                url: '/manufacturing',
            },
            {
                id: 6,
                label: 'Shipping',
                icon: SettingsIcon,
                url: "/shipping",
            },
            {
                id: 9,
                label: 'Finished Product Stocks',
                icon: SettingsIcon,
                url: "/product-stocks",
            },
            {
                id: 12,
                label: 'Raw Tea',
                icon: TeaIcon,
                url: "/raw-tea",
            },
            {
                id: 13,
                label: 'Blended Tea',
                icon: TeaIcon,
                url: "/blended-tea",
            },
            {
                id: 14,
                label: 'Common BOM',
                icon: SettingsIcon,
                url: "/common-bom",
            },
        ],
        purchase: [
            {
                id: 1,
                label: 'Dashboard',
                icon: DashboardIcon,
                childrens: null,
                url: '/'
            },
            {
                id: 3,
                label: 'Purchase',
                icon: SalesRepIcon,
                url: '/purchase',
            },
            {
                id: 8,
                label: 'Suppliers',
                icon: SettingsIcon,
                url: "/suppliers",
            },
            {
                id: 7,
                label: 'Stocks',
                icon: SettingsIcon,
                url: "/purchase-stocks",
            },
            {
                id: 12,
                label: 'Common BOM',
                icon: SettingsIcon,
                url: "/common-bom",
            },
        ],
        admin: [
            {
                id: 1,
                label: 'Dashboard',
                icon: DashboardIcon,
                childrens: null,
                url: '/'
            },
            {
                id: 2,
                label: 'Sales',
                icon: OrdersIcon,
                childrens: null,
                url: '/sales'
            },
            {
                id: 3,
                label: 'Purchase',
                icon: SalesRepIcon,
                url: '/purchase',
            },
            {
                id: 4,
                label: 'Manufacturing',
                icon: SalesRepIcon,
                url: '/manufacturing',
            },
            {
                id: 6,
                label: 'Shipping',
                icon: SettingsIcon,
                url: "/shipping",
            },
            {
                id: 5,
                label: 'Buyers',
                icon: SettingsIcon,
                url: "/buyers",
            },
            {
                id: 8,
                label: 'Suppliers',
                icon: SettingsIcon,
                url: "/suppliers",
            },
            {
                id: 10,
                label: 'Gardens',
                icon: FarmIcon,
                url: "/gardens",
            },
            {
                id: 11,
                label: 'Warehouse',
                icon: WarehouseIcon,
                url: "/warehouse",
            },
            {
                id: 12,
                label: 'Raw Tea',
                icon: TeaIcon,
                url: "/raw-tea",
            },
            {
                id: 13,
                label: 'Blended Tea',
                icon: TeaIcon,
                url: "/blended-tea",
            },
            {
                id: 8,
                label: 'Stocks',
                icon: SettingsIcon,
                url: "/purchase-stocks",
            },
            {
                id: 12,
                label: 'Common BOM',
                icon: SettingsIcon,
                url: "/common-bom",
            },
            {
                id: 14,
                label: 'Updates',
                icon: SettingsIcon,
                url: "/updates",
            },
            {
                id: 9,
                label: 'Finished Product Stocks',
                icon: SettingsIcon,
                url: "/product-stocks",
            },
            {
                id: 10,
                label: 'Users',
                icon: SettingsIcon,
                url: '/users'
            },
            {
                id: 11,
                label: 'Settings',
                icon: SettingsIcon,
                url: '/settings'
            }
        ]
    };

    const data = useMemo(() => roleBasedMenuItems[authInfo.role] || [], [authInfo.role]);

    return (
        <div className='w-auto h-screen flex transition-all'>
            <div className={`hidden md:block bg-[#FBFCFE] border-r border-r-[#efefef] shrink-0 max-w-[280px] transition-all duration-[300ms] w-full h-screen overflow-scroll`}>
                <div className='flex justify-between px-8 py-4 items-center transition-all duration-[300ms]'>
                    {!collapsed ? <img src={Logo} className='h-10 w-auto'/> : null}
                    <div className='h-[32px] w-[32px] '></div>
                </div>
                <div className='w-auto mt-8 px-4'>
                    {data.map((item,index)=>
                        <SidebarMenuItem 
                            collapsed={collapsed} 
                            data={item} 
                            key={index} 
                            setActive={setActiveMenu} 
                            active={activeMenu}
                        />
                    )}
                    <div className={`w-full flex px-4 items-center cursor-pointer `} onClick={onLogout}>
                        <div className='w-full flex items-center'>
                            <div className='py-2'>
                                <BiLogOut color={'#000'} fontSize={20}/>
                            </div>
                            <div className='ml-4'>
                                <p className='text-[14px] tracking-[-.15px] font-medium text-[#000] '>Logout</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`md:hidden fixed z-[99] w-screen bg-[#0F172A] h-auto transition-all duration-[300ms] ${collapsed ? 'w-[80px]': 'w-full'}`}>
                <div className='flex justify-between px-8 py-5 items-center transition-all duration-[300ms]'>
                    <div className='h-[18px] w-[18px]'></div>
                </div>
            </div>
            <div className='flex flex-col mt-16 md:mt-0 h-screen w-full bg-white px-0 z-10'>
                <Outlet/>
            </div>
        </div>
    )
}

export default React.memo(Sidebar)
